import React, { useState } from "react";
import SmartTile from "./common/SmartTile";
import ConfirmModal from "./common/ConfirmModal";
import { canDelete } from "../utils/permissions";
import { FaFolder } from "react-icons/fa";

export default function FolderCard({
  folder,
  user,
  onEnter,          // (id, path) => void
  onDelete,         // async (id) => void
  canManage,        // boolean (usually isAdmin)
}) {
  const [showConfirm, setShowConfirm] = useState(false);

  const allowDelete = canManage && canDelete(folder, user);

  return (
    <>
      <SmartTile
        icon={<FaFolder style={{ color: "var(--primary)" }} />}
        title={folder?.name || "Untitled"}
        onClick={() => onEnter(folder.id, folder.path)}
        onDelete={allowDelete ? () => setShowConfirm(true) : undefined}
        deleteLabel="Delete folder"
        ariaLabel={`Open ${folder?.name}`}
        iconSize="18px"
        className="folder-card-compact"
      />

      <ConfirmModal
        show={showConfirm}
        title="Delete Folder"
        message={`Are you sure you want to delete "${folder?.name}"?`}
        onCancel={() => setShowConfirm(false)}
        onConfirm={async () => {
          setShowConfirm(false);
          await onDelete(folder.id);
        }}
      />
    </>
  );
}
